import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import 'ag-charts-enterprise';
import { AgCharts } from 'ag-charts-react';
import { exportDataPlugin } from './plugins/ExportDataPlugin';
const DEFAULT_OPTIONS = {
    contextMenu: {
        items: ['defaults'],
    },
};
export const CustomAgChart = forwardRef(({ options, plugins = [exportDataPlugin], ...props }, forwardedRef) => {
    // ... The reference to the AG Chart
    const chartRef = useRef(null);
    // ... Required to be able to use the forwardedRef object
    useImperativeHandle(forwardedRef, () => chartRef.current, []);
    // ... Merge default props with passed props
    let mergedProps = {
        ...DEFAULT_OPTIONS,
        ...options,
    };
    // ... Activate plugins augment options function
    for (const plugin of plugins) {
        if (plugin.augmentOptions) {
            mergedProps = plugin.augmentOptions(mergedProps);
        }
    }
    // ... Notify plugins when chart is ready
    useEffect(() => {
        if (chartRef.current) {
            plugins.forEach((p) => p.onChartReady?.(chartRef.current));
        }
    }, [plugins]);
    return _jsx(AgCharts, { ref: chartRef, options: mergedProps, ...props });
});
